import React, { CSSProperties, ReactElement } from "react";
import { Nullable } from "@sade/data-access";

type LoaderSizeName = "small" | "medium";
export type LoaderSize = LoaderSizeName | number;

const LOADER_SIZES: { [k in LoaderSizeName]: number } = {
  small: 1.3,
  medium: 3,
};

function getLoaderSize(size?: LoaderSize): number {
  if (size == null) {
    return LOADER_SIZES.medium;
  } else if (typeof size === "number") {
    return size;
  } else {
    return LOADER_SIZES[size];
  }
}

function circleThicknessFromSize(size: number): number {
  return Math.max(0.2, 0.15 * size);
}

interface Props {
  show?: boolean;
  rotationSpeedInSeconds?: number;
  size?: LoaderSize;
  spinnerColor?: string;
  circleColor?: string;
  topBottomPadding?: string;
  leftRightPadding?: string;
  hidden?: boolean;
  styles?: CSSProperties;
}

export default function Loader(props: Props): Nullable<ReactElement> {
  const {
    show,
    rotationSpeedInSeconds,
    size,
    spinnerColor,
    circleColor,
    topBottomPadding,
    leftRightPadding,
    hidden,
    styles,
  } = props;

  if (show != null && !show) {
    return null;
  }

  const sizeNumber = getLoaderSize(size);

  const rotationSpeed = rotationSpeedInSeconds || "1";
  const spinnerSize = `${sizeNumber}rem`;
  const colorS = spinnerColor || "#da262e";
  const colorC = circleColor || "#f3f3f3";
  const heightC = `${circleThicknessFromSize(sizeNumber)}rem`;
  const paddingTopBottom = topBottomPadding || "2rem";
  const paddingLeftRight = leftRightPadding || "0";
  const containerStyles: CSSProperties = {
    ...styles,
    padding: paddingTopBottom + " " + paddingLeftRight,
    visibility: hidden ? "hidden" : "visible",
  };
  const loaderStyles = {
    animation: "spin " + rotationSpeed + "s linear infinite",
    border: heightC + " solid " + colorC,
    borderRadius: "50%",
    borderTop: heightC + " solid " + colorS,
    height: spinnerSize,
    margin: "0 auto",
    width: spinnerSize,
  };
  return (
    <div style={containerStyles}>
      <div style={loaderStyles} data-testid="loader" />
    </div>
  );
}
